import { Nav } from "./Nav"

export const Search = () => {
    // TODO: mock up the visualisations / table for the search
    // TODO: add calculator tools
    return (
        <div>
            <Nav />
            <div className="m-4">

                <h2 className="text-l font-bold">Search page</h2>
                <div className="flex m-4 p-4">
                    <form action="" method="POST" className="flex flex-col gap-4">
                        <div className="flex flex-col gap-2 w-80">
                            <label htmlFor="address">Address</label>
                            <input type="text" name="address" id="address" required />
                        </div>
                        <div className="flex flex-col gap-2 w-80">
                            <label htmlFor="postcode">Postcode</label>
                            <input type="text" name="postcode" id="postcode" required />
                        </div>
                        <div className="flex flex-col gap-2 w-80">
                            <label htmlFor="bedrooms">Number of bedrooms</label>
                            <input type="number" min="0" max="30" name="bedrooms" id="bedrooms" required />
                        </div>
                        <div className="flex flex-col gap-2 w-80">
                            <label htmlFor="bathrooms">Number of bathrooms: </label>
                            <input type="number" min="0" max="30" name="bathrooms" id="bathrooms" required />
                        </div>
                        <div className="flex flex-col gap-2 w-80">
                            <input className="border-solid border-2 border-black rounded-md p-2" type="submit" value="Submit" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}